<template>
	<div class="table" >
		<table v-if="patient.row" :class="patient.row.length > 1 ? 'multiple' : 'single'">
			<tbody>
				<tr v-for="row in showRows">
					<td v-if="!show">
						<span class="skip"><i class="el-icon-more-outline"></i></span>
					</td>
					<td v-for="(column, index) in row" :key="index">
						<span v-if="column != null && showColumn(index)">{{ column }}</span>
						<span class="skip" v-else><i class="el-icon-more-outline"></i></span>
					</td>
					<td class="show">
						<el-button @click="toggleShow" type="text" size="mini">
							<b>{{ show ? 'hide all' : 'show all' }}</b>
						</el-button>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
export default {
	name: 'import-data-row',

	props: {
		patient: {
			type: Object,
			required: true
		},
		column: {
			type: Object,
			required: true
		},
		highlight: {
			type: Array
		},
		error: {
			type: Array
		},
		showPatient: {
			type: Array
		}
	},

	data() {
		return {
			show: false
		}
	},

	methods: {
		showColumn(index) {
			return this.show || this.highlightIndex == null || this.highlightIndex.includes(index)
		},
		toggleShow() {
			this.show = ! this.show
		}
	},

	computed: {
		highlightIndex() {
			if (this.highlight) {
				var index = {}
				Object.keys(this.column).forEach((column) => {
					if (this.highlight.includes(column))
						Object.keys(this.column[column]).forEach((i) => {
							index[i] = true
						})
				})
				return Object.keys(index).map((i) => parseInt(i))
			}
			else return null
		},
		showRows() {
			if(this.showPatient) {
				const showRowsIndex = this.showPatient.map((row) => row.row)
				return this.patient.row.filter((row, index) => showRowsIndex.includes(index))
			}
			return this.patient.row
		}
	}
}
</script>
<style lang="scss" scoped>
@import "style.scss";
</style>
